
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import { Banner } from '@/types/banner';

@Component
export default class BannerEditor extends Vue {
  @Prop() banner!: Banner;
  @Prop() pageTitle!: string;
  @Prop() pageStrapline!: string;
  @Prop() categoryBanner!: boolean;
  @Mutation('pageEditor/setPageBannerColour') setPageBannerColour!: Function;
  @Mutation('pageEditor/setPageBannerBackground')
  setPageBannerBackground!: Function;
  @Mutation('pageEditor/setPageBannerIcon') setPageBannerIcon!: Function;
  @Mutation('categories/setCategoryBannerColour')
  setCategoryBannerColour!: Function;
  @Mutation('categories/setCategoryBannerBackground')
  setCategoryBannerBackground!: Function;
  @Mutation('categories/setCategoryBannerIcon')
  setCategoryBannerIcon!: Function;

  colours: object = [
    { text: 'Aubergine', value: null },
    { text: 'Blue', value: 'bg-colour-blue' },
    { text: 'Cyan', value: 'bg-colour-cyan' },
    { text: 'Green', value: 'bg-colour-green' },
    { text: 'Grass Green', value: 'bg-colour-grass-green' },
    { text: 'Orange', value: 'bg-colour-orange' },
    { text: 'Yellow', value: 'bg-colour-yellow' },
    { text: 'Pink', value: 'bg-colour-pink' },
  ];

  backgrounds: object = [
    { text: 'None', value: null },
    { text: 'Blocks', value: 'bg-icon-future' },
    { text: 'Buildings', value: 'bg-icon-building' },
    { text: 'Charts', value: 'bg-icon-chart' },
    { text: 'Exit', value: 'bg-icon-exit' },
    { text: 'Graphs', value: 'bg-icon-graph' },
    { text: 'Lightbulbs', value: 'bg-icon-lightbulb' },
    { text: 'Money', value: 'bg-icon-money' },
    { text: 'Pigs', value: 'bg-icon-pig' },
    { text: 'Roads', value: 'bg-icon-road' },
    { text: 'Rockets', value: 'bg-icon-rocket' },
    { text: 'Shapes', value: 'bg-icon-shapes' },
    { text: 'Traffic Lights', value: 'bg-icon-traffic-lights' },
    { text: 'Trees', value: 'bg-icon-tree' },
    { text: 'Vans', value: 'bg-icon-van' },
  ];

  icons: object = [
    { text: 'None', value: null },
    { text: 'Blocks', value: 'future-icon' },
    { text: 'Building', value: 'building-icon' },
    { text: 'Chart', value: 'chart-icon' },
    { text: 'Exit', value: 'exit-icon' },
    { text: 'Graph', value: 'graph-icon' },
    { text: 'Lightbulb', value: 'lightbulb-icon' },
    { text: 'Money', value: 'money-icon' },
    { text: 'Pig', value: 'pig-icon' },
    { text: 'Road', value: 'road-icon' },
    { text: 'Rocket', value: 'rocket-icon' },
    { text: 'Shapes', value: 'shapes-icon' },
    { text: 'Traffic Lights', value: 'traffic-lights-icon' },
    { text: 'Tree', value: 'tree-icon' },
    { text: 'Van', value: 'van-icon' },
    { text: 'Road (FAQ)', value: 'road-faq-icon' },
    { text: 'Pound Sign (FAQ)', value: 'pound-faq-icon' },
    { text: 'Contract (FAQ)', value: 'contract-faq-icon' },
    { text: 'Check Mark (FAQ)', value: 'check-faq-icon' },
    { text: 'Question Mark (FAQ)', value: 'question-faq-icon' },
  ];

  get colour() {
    return this.banner !== null ? this.banner.colour : null;
  }
  set colour(value) {
    this.categoryBanner
      ? this.setCategoryBannerColour(value)
      : this.setPageBannerColour(value);
  }

  get background() {
    return this.banner !== null ? this.banner.background : null;
  }
  set background(value) {
    this.categoryBanner
      ? this.setCategoryBannerBackground(value)
      : this.setPageBannerBackground(value);
  }

  get icon() {
    return this.banner !== null ? this.banner.icon : null;
  }
  set icon(value) {
    this.categoryBanner
      ? this.setCategoryBannerIcon(value)
      : this.setPageBannerIcon(value);
  }
}
